'use strict';

(function (angular) {
    BasketController.$inject = ['$scope', '$log', '$anchorScroll', '$window', '$location', '$timeout', 'dataService', 'productService', 'basketService', 'contentService', 'BASKET_ID', 'SETTINGS', 'trackAddToBasketService'];
    angular
        .module('jwsdw.basket')
        .config(['$locationProvider', function($locationProvider) {
            $locationProvider.html5Mode(true);
            // $locationProvider.hashPrefix('?');
        }])
        .controller('BasketController', BasketController);

    /**
     * @class jwsdwBasket.BasketController
     * @description Method to initialize the basket page functionality
     * @param {Object} $scope current scope
     * @param {Object} $log log service that provides logging in angluar
     * @param {Object} $anchorScroll service to allow scrolling on the page
     * @param {Object} $window browser window object
     * @param {Object} $location browser location object
     * @param {Object} $timeout angular timeout service
     * @param {Object} dataService service to provide access data layer of the basket
     * @param {Object} productService service to provide product information (used for creation of variants item)
     * @param {Object} basketService service to provide basket information
     * @param {Object} contentService service to provide content information via OCAPI
     * @param {String} BASKET_ID basket id of the current basket provided through demandware backend (window.jwsdwSettings) and loaded into the module as constant
     * @param {String} SETTINGS window jwsdwSettings
     * @param {Object} trackAddToBasketService trackAddToBasketService
     * @constructor
     */
    function BasketController($scope, $log, $anchorScroll, $window, $location, $timeout, dataService, productService, basketService, contentService, BASKET_ID, SETTINGS, trackAddToBasketService) { // eslint-disable-line max-len, max-params, max-statements
        var vm = this;

        vm.dataService = dataService;
        vm.productService = productService;

        vm.proceedingToCheckout = false;
        vm.proceedingToDirectCheckout = false;

        vm.updating = false;
        vm.sessionError = false;
        vm.invalidProductError = false;
        vm.quantityError = false;
        vm.bonusProductActive = true;
        vm.couponCode = '';
        vm.gPayLoaded = false;
        vm.bonusProductIncompleteError = false;
        vm.bonusProductWithNormalProductError = false;
        vm.maxCartQuantityPerItem = SETTINGS.maxCartQuantityPerItem;
        vm.quantityOptions = [];
        vm.couponInputRevealed = false;
        vm.recommendedProductDismissed = false;
        vm.recommendedProductObserver = null;
        vm.refusalReason = $location.search().reason || undefined;
        vm.currentVoucher = undefined;
        vm.voucherSectionUpdating = false;
        vm.generalBasketError = null;

        /* Wishlist handling */
        vm.wishlistCount = SETTINGS.wishlistCount || 0;
        vm.maxWishlistItemsForGuest = SETTINGS.maxWishlistItemsForGuest || 0;
        vm.wishlist = SETTINGS.wishlist;

        //public methods
        vm.removeItem = removeItem;
        vm.onRemoveButtonClick = onRemoveButtonClick;
        vm.onRemoveCancelButtonClick = onRemoveCancelButtonClick;
        vm.updateQuantity = updateQuantity;
        vm.updateProduct = updateProduct;
        vm.addCoupon = addCoupon;
        vm.removeCoupon = removeCoupon;
        vm.removeBonusCoupon = removeBonusCoupon;
        vm.toggleBonusProduct = toggleBonusProduct;
        vm.checkout = checkout;
        vm.directCheckout = directCheckout;
        vm.onEditButtonClick = onEditButtonClick;
        vm.onBonusProductAddToCartClick = onBonusProductAddToCartClick;
        vm.openPriceOverridePicker = openPriceOverridePicker;
        vm.openVoucherPicker = openVoucherPicker;
        vm.onMoveToWishlistButtonClick = onMoveToWishlistButtonClick;
        vm.onMoveToWishlistCancelButtonClick = onMoveToWishlistCancelButtonClick;
        vm.moveItemToWishlist = moveItemToWishlist;
        vm.toggleCouponInput = toggleCouponInput;
        vm.addRecommendedProduct = addRecommendedProduct;
        vm.addBonusItem = addBonusItem;
        vm.onRemoveRecommButtonClick = onRemoveRecommButtonClick;
        vm.selectVoucher = selectVoucher;
        vm.addVoucherToBasket = addVoucherToBasket;

        /* Map to manage focusable elements */
        $scope.focusMap = new Map();

        /**
         * @description Method to run the initialization of the basket module
         * @returns {void}
         */
        this.$onInit = function () {
            dataService.init(function() {
                vm.errorMessage = dataService.errorMessages();

                // check for invalid products
                dataService.productItems().forEach(function(product) {
                    if (!product.hasOwnProperty('price') || typeof product.price !== 'number') {
                        removeItem(product);
                        vm.invalidProductError = true;

                        if (product.isBonusProduct) {
                            // prevent bonusproduct selection picker from reappearing
                            $window.sessionStorage.setItem('jwsdw-choiceOfBonusProductPicker', 'hide');
                        }
                    }
                });

                if (dataService.recommendedProductItem() && !vm.recommendedProductObserver) {
                    _initObserver(dataService.recommendedProductItem());
                }

                if (!vm.gPayLoaded && window.googlePay && dataService.applicablePaymentMethods().indexOf('GOOGLE_PAY') > -1) {
                    $.getScript("https://pay.google.com/gp/p/js/pay.js", function() {
                        vm.gPayLoaded = true;
                        window.googlePay.onLoaded();
                    });
                }

                /*
                    Logic to first show the order limit reached message as a general banner on the basket page when first landing on it,
                    whether it's due to the reason URL param or from pdict information.
                */
                if (vm.refusalReason === undefined) {
                    vm.refusalReason = dataService.refusalReason();
                }

                /*
                    The general banner disappears once the order limit is not an issue anymore.
                    If the limit is an issue again (eg. if the customer updates a product's quantity), then the order limit message is shown above the 'Checkout' button
                */
                if (vm.refusalReason === 'orderLimit' && !dataService.orderLimitReached()) {
                    vm.refusalReason = null;

                    if ($location.search().reason) {
                        $location.search('reason', null).replace();
                    }
                }

                vm.orderLimitMsg = dataService.orderLimitMsg();
                vm.showShippingNotification = dataService.showShippingNotification();

                trackViewCart();

                updateProgressBar();

                window.jwsdwMediator.subscribe('basket:loading:start', function () {
                    $timeout(function() {
                        $scope.$apply(function() {
                            vm.updating = true;
                        });
                    });
                });

                window.jwsdwMediator.subscribe('basket:loading:stop', function () {
                    $timeout(function() {
                        $scope.$apply(function() {
                            vm.updating = false;
                        });
                    });
                });
            });

            populateCartQuantityOptions();

            // listen to the 'sessionExpired' event broadcasted by the mediator
            $window.jwsdwMediator.subscribe('sessionExpired', function() {
                $anchorScroll();
                vm.sessionError = true;
            });

            // listen to the 'updateBasket' event broadcasted by the mediator
            $window.jwsdwMediator.subscribe('updateBasket', function() {
                dataService.init();
            });

            // listen to the 'updateBasket' event broadcasted by the mediator
            $window.jwsdwMediator.subscribe('updateBasketProduct', function(data) {
                updateProduct(data.itemId, data.initialProductId, data.variantId, data.quantity, data.product);
            });


            // listen to the 'updateBonusProduct' event broadcasted by the mediator
            $window.jwsdwMediator.subscribe('updateBonusProduct', function(data) {
                updateBonusProduct(data.itemId, data.initialProductId, data.variantId, data.product, data.isUpdateBonusProduct);
            });

            /* Update basket quantity dynamically */
            $window.jwsdwMediator.subscribe('setCartCount', function(cartQuantity) {
                vm.productCount = cartQuantity;
            });

            /* Listen for general basket errors */
            $window.jwsdwMediator.subscribe('basket:error', function(errorMessage) {
                $timeout(function() {
                    $scope.$apply(function() {
                        vm.generalBasketError = errorMessage;
                    });
                });
            });

            /* Listen for general basket errors */
            $window.jwsdwMediator.subscribe('basket:clearerror', function() {
                $timeout(function() {
                    $scope.$apply(function() {
                        vm.generalBasketError = null;
                    });
                });
            });

            //if data service publishes a qunatity error the view model parameter is set to true as well
            $scope.$watch(function () {
                return dataService.quantityError;
            }, function () {
                vm.quantityError = dataService.quantityError;
            });
        };

        /**
         * Method that is triggered if user clicks edit button for a product.
         * It broadcasts the 'openPicker' event for 'variationPicker' with the product as payload.
         * The Listener is registered in the variationPicker.controller.js
         * @param {Object} product the product which should be edited
         * @param {Boolean} isBonus optional parameter, true if current product is of type bonus
         * @returns {void}
         */
        function onEditButtonClick(product, isBonus) {
            $window.jwsdwMediator.publish('openPicker', 'variationPicker', {
                'product': product,
                'dataService': dataService,
                'isBonus': isBonus,
                'isUpdateBonusProduct': true
            });
        }

        /**
         * Method that is triggered if user clicks edit button for a product.
         * It broadcasts the 'openPicker' event for 'variationPicker' with the product as payload.
         * The Listener is registered in the variationPicker.controller.js
         * @param {String} bonusProductId the product id which should be edited and added to cart
         * @param {Boolean} isBonus optional parameter, true if current product is of type bonus
         * @returns {void}
         */
        function onBonusProductAddToCartClick(bonusProductId) {
            vm.bonusProductIncompleteError = false;
            vm.bonusProductWithNormalProductError = false;
            productService.getProduct(bonusProductId).then((product) => {
                window.jwsdwMediator.publish('openPicker', 'variationPicker', {
                    product,
                    dataService,
                    isBonus: true,
                    isUpdateBonusProduct: false
                });
            });
        }

        /**
         * @description Method to open the product remove overlay.
         * @param {Object} product - The product which should be removed.
         * @returns {undefined}
         */
        function onRemoveButtonClick(product) {
            product.markedForRemoval = true;
            vm.bonusProductIncompleteError = false;
            vm.bonusProductWithNormalProductError = false;
        }

        /**
         * @description Method to add multiple items to the basket.
         * @param {Object} recommendedProduct recommended product object
         * @returns {undefined}
         */
        function _initObserver(recommendedProduct) {
            $timeout(() => {
                let recommendationBlock;
                let observer = new IntersectionObserver(entries => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            let sendEvent = trackAddToBasketService.sendRecommendedProductImpressions.bind(this, recommendedProduct, 1);
                            $window.jwsdwApi.tracking.ensureConsent(sendEvent);
                            observer.disconnect();
                        }
                    });
                }, {
                    'root': null,
                    'rootMargin': '0px',
                    'threshold': 1.0
                });

                recommendationBlock = document.getElementById('recommendationBlock');
                observer.observe(recommendationBlock);
                vm.recommendedProductObserver = true;
            });
        }

        /**
         * @description Method to open the product move to wishlist overlay.
         * @param {Object} product - The product which should be moved to the wishlist.
         * @returns {undefined}
         */
        function onMoveToWishlistButtonClick(product) {
            product.markedForWishlist = true;
        }

        /**
         * @description Method to close the product remove overlay.
         * @param {Object} product - The product whose removal overlay should be closed.
         * @returns {undefined}
         */
        function onRemoveCancelButtonClick(product) {
            product.markedForRemoval = false;

            /* Restore focus to corresponding close button */
            let closeButton = $scope.focusMap.get(product.basketItemId);

            $timeout(() => {
                if (closeButton && closeButton.focus) {
                    closeButton.focus();
                }
            });
        }

        /**
         * @description Method to close the product move to wishlist overlay.
         * @param {Object} product - The product whose move to wishlist overlay should be closed.
         * @returns {undefined}
         */
        function onMoveToWishlistCancelButtonClick(product) {
            product.markedForWishlist = false;
        }

        /**
         * @description Method to trigger removal of a product from the basket. This method triggers the basket service.
         * @param {Object} product - The product which should be removed from the basket.
         * @param {boolean} markForRemoval - Boolean parameter to determine whether to also mark the product for removal.
         * @returns {void}
         */
        function removeItem(product, markForRemoval) {
            vm.bonusProductIncompleteError = false;
            vm.bonusProductWithNormalProductError = false;
            if (markForRemoval) {
                product.markedForRemoval = true;
            }

            product.removing = true;

            basketService.removeItem(product.basketItemId).then((basketData) => {
                product.removed = true;
                product.removing = false;
                trackRemoveFromCart(product);
                $timeout(() => {
                    product.tileHeight = angular.element(`[data-item-id=${product.basketItemId}]`).outerHeight() + 'px';
                    product.fadeOut = true;
                    $timeout(() => {
                        dataService.basketSuccess(basketData);
                    }, 1000);
                }, 2000);
            });
        }

        /**
         * @description Method to trigger removal of a product from the basket and its addition to the wishlist. This method triggers the basket service.
         * @param {Object} product - The product which should be moved to the wishlist.
         * @returns {undefined}
         */
        function moveItemToWishlist(product) {
            product.movingToWishlist = true;

            if (!window.jwsdwSettings.customerAuthenticated && vm.wishlistCount === vm.maxWishlistItemsForGuest) {
                product.movingToWishlist = false;
                window.jwsdwMediator.publish('openPicker', 'loginPicker', {
                    'showMaxGuestWishlistMessage': true,
                    'callback': function() {
                        moveItemToWishlist(product);
                    }
                });
                return;
            }

            productService.addToWishlist(product.id).then(addToWishlistSuccess, addToWishlistError);

            /**
             * @description Method on success
             * @param {Object} data response data
             * @returns {undefined}
             */
            function addToWishlistSuccess(data) {
                vm.wishlist.products.push({
                    'id': data.itemId,
                    'pid': data.productId,
                    'color': data.color
                });

                window.jwsdwMediator.publish('setWishlistCount', data.items);

                _trackAddToWishlist(product);

                basketService.removeItem(product.basketItemId).then((basketData) => {
                    product.movedToWishlist = true;
                    product.movingToWishlist = false;
                    $timeout(() => {
                        product.tileHeight = angular.element(`[data-item-id=${product.basketItemId}]`).outerHeight() + 'px';
                        product.fadeOut = true;
                        $timeout(() => {
                            dataService.basketSuccess(basketData);
                        }, 1000);
                    }, 2000);
                });
            }

            /**
             * @description Method on error
             * @returns {undefined}
             */
            function addToWishlistError() {
                product.movingToWishlist = false;
            }
        }

        /**
         * @description Method to trigger update of a product quantity in the basket.
         * This method checks if the new quantity is valid and then triggers the basket service.
         * @param {Object} product - The basket product for which the quantity should be updated.
         * @returns {undefined}
         */
        function updateQuantity(product) {
            if (dataService.checkValidQuantity(product.basketItemId, product.quantity, product.stock)) {
                _refreshProductView(
                    product,
                    basketService
                        .updateQuantity(product.basketItemId, product.quantity)
                        .then(dataService.basketSuccess)
                );
            }
        }

        /**
         * @description Method to update a product via the variation picker using the basketService. The method checks if the product changed
         * and then adds the new product to the basket and then removes the old one.
         * @param {String} itemId itemId
         * @param {String} initialProductId initialProductId
         * @param {String} variantId Id of the variant that should replace the old product
         * @param {Number} quantity quantity for the product. This is the same if enough stock is available for the
         * new variant otherwise the maximum stock will be used.
         * @param {Object} product the product object of the new variant
         * @returns {void}
         */
        function updateProduct(itemId, initialProductId, variantId, quantity, product) {
            if (initialProductId !== variantId) {
                basketService.addItem(variantId, quantity, product).then(function() {
                    _refreshBasketView(
                        basketService
                            .removeItem(itemId)
                            .then(dataService.basketSuccess)
                    );
                });
            }
        }

        /**
         * @description Method to update a bonus product via the variation picker using the basketService. The method checks if the product changed
         * and then adds the new product to the basket and then removes the old one.
         * @param {String} itemId itemId
         * @param {String} initialProductId initialProductId
         * @param {String} variantId Id of the variant that should replace the old product
         * @param {Object} product the product object of the new variant
         * @param {Boolean} isUpdateBonusProduct flag to determine if the bonus product should be updated
         * @returns {void}
         */
        function updateBonusProduct(itemId, initialProductId, variantId, product, isUpdateBonusProduct) {
            if (isUpdateBonusProduct) {
                if (initialProductId !== variantId) {
                    basketService.removeItem(itemId).then(function () {
                        _refreshBasketView(
                            basketService
                                .addBonusItem(variantId, product)
                                .then(dataService.basketSuccess)
                        );
                    });
                }
            } else {
                _refreshBasketView(
                    basketService
                        .addBonusItem(variantId, product)
                        .then(dataService.basketSuccess)
                );
            }
        }

        /**
         * @description Method to add a recommended product to basket
         * @param {String} productID productID
         * @param {String} quantity quantity
         * @param {Object} product product
         * @returns {void}
         */
        function addRecommendedProduct(productID, quantity, product) {
            _refreshBasketView(
                basketService
                    .addItem(productID, quantity, product, true)
                    .then(dataService.basketSuccess)
            );
            vm.recommendedProductDismissed = true;
        }

        /**
         * @description Method to add a bonus product to basket
         * @param {String} productID productID
         * @param {Object} product product
         * @returns {void}
         */
        function addBonusItem(productID, product) {
            _refreshBasketView(
                basketService
                    .addBonusItem(productID, product)
                    .then(dataService.basketSuccess)
            );
            vm.isRemovedBonusProduct = false;
        }

        /**
         * @description Method to remove a recommended product block
         * @returns {void}
         */
        function onRemoveRecommButtonClick() {
            vm.recommendedProductDismissed = true;
        }

        /**
         * @description Method to add a coupon to the basket using the basketService.
         * The logic first tries to add the coupon as entered by the user.
         * If the request fails it retries with uppercase and lowercase variants of the coupon.
         * @returns {void}
         */
        function addCoupon() {
            // logic tries the coupon code as it was entered by the user
            // if no matching code can be found tries uppercase and lowercase versions of the code
            // if still no code is found an error message is displayed

            // frontend validation
            if (!$('.jwsdw-basket-couponArea-form').valid()) {
                return;
            }

            _refreshBasketView(
                basketService
                    .addCoupon(vm.couponCode)
                    .then(couponSuccess, couponError)
            );
        }

        /**
         * @description Method to handle successful responses from the add coupon code function.
         * It handles if and how coupons are displayed in the basket and shows errors otherwise.
         * Cases:
         * valid and applied - coupon is displayed as applied
         * valid and not applied - coupon is displayed as not applied
         * not valid - error no coupon is displayed, error message coupon not found
         * @param {Object} basketData current basket data
         * @returns {void}
         */
        function couponSuccess(basketData) {
            var couponItem;

            dataService.basketSuccess(basketData);
            couponItem = dataService.couponItems()
                .concat(dataService.couponGiftCertificateItems())
                .find(function(coupon) {
                    return coupon.code.toUpperCase() === vm.couponCode.toUpperCase();
                });

            //check the status of the received coupon
            if (couponItem && couponItem.valid) {
                vm.couponCode = '';
            }
        }

        /**
         * @description Method to handle unsuccessful responses for coupon code calls.
         * @param {Object} errorData current error data
         * @returns {void}
         */
        function couponError(errorData) {
            $('.jwsdw-basket-couponArea-form').validate().showErrors({
                "basketCouponCode": errorData.details.message
            });
        }

        /**
         * @description Method to remove a coupon from the basket using the basketService.
         * @param {String} couponId id of the coupon that should be removed
         * @returns {void}
         */
        function removeCoupon(couponId) {
            _refreshBasketView(
                basketService
                    .removeCoupon(couponId)
                    .then(dataService.basketSuccess)
            );
        }

        /**
         * @description Method to remove a coupon from the basket using the basketService.
         * @param {String} couponCode coupon code that should be removed
         * @returns {void}
         */
        function removeBonusCoupon(couponCode) {
            _refreshBasketView(
                basketService
                    .removeBonusCoupon(couponCode)
                    .then(dataService.basketSuccess)
            );
        }

        /**
         * @description Method to open the price override picker. It calculates the adjusted product pice without previous manual adjustments.
         * @param {Object} product the product which should be edited
         * @returns {void}
         */
        function openPriceOverridePicker(product) {
            var regex = new RegExp('\\d{5,7}-\\d-' + product.id),
                adjustmentTotal = 0,
                manualAdjustments = product.priceAdjustments.filter(function (priceAdjustment) {
                    $log.info('regexp: ' + regex.toString());
                    $log.info('adjustment: ' + priceAdjustment.promotionId);
                    $log.info('adjustment matches: ' + regex.test(priceAdjustment.promotionId));
                    return regex.test(priceAdjustment.promotionId);
                });

            manualAdjustments.forEach(function (manualAdjustment) {
                adjustmentTotal = adjustmentTotal + (manualAdjustment.price * -1);
            });

            window.jwsdwMediator.publish('openPicker', 'priceOverridePicker', {
                'productId': product.id,
                'oldPrice': adjustmentTotal > 0 ? product.priceAfterItemDiscount + adjustmentTotal : product.priceAfterItemDiscount
            });
        }


        /**
         * Method open info picker with Checkout-redeem-coupons content
         * @returns {void}
         */
        function openVoucherPicker() {
            contentService.getContent('Checkout-redeem-coupons').then(success, error);

            /**
             * Method called on success
             * @param {Object} response response object
             * @returns {void}
             */
            function success(response) {
                $window.jwsdwMediator.publish('openPicker', 'infoPicker', {
                    'width': 1,
                    'content': response.content,
                    'isVisible': true,
                    'level': 2
                });
            }

            /**
             * Method called on error
             * @param {Object} err error object
             * @returns {void}
             */
            function error(err) {
                $log.error('Could not fetch content asset "Checkout-redeem-coupons"', err);
            }
        }

        /**
         * @description Method to toggle the bonus product.
         * This method is currently not in use since demandware has no internal logic to remove bonus products from basket.
         * @returns {void}
         */
        function toggleBonusProduct() {
            vm.bonusProductActive = !vm.bonusProductActive;
        }

        /**
         * @description Method to validate the basket and if validation is successful direct the customer to the checkout.
         * @returns {void}
         */
        function checkout() {
            vm.bonusProductIncompleteError = false;
            vm.bonusProductWithNormalProductError = false;

            if (isGiftIncomplete()) {
                vm.bonusProductIncompleteError = true;
                $('html, body').animate({
                    'scrollTop': angular.element('.jwsdw-bonus-product-errors-container').offset().top - 100
                });
                return;
            }

            if (isMixedBasket() && vm.dataService.shouldExcludeProductPurchaseWithPromotion()) {
                vm.bonusProductWithNormalProductError = true;
                $('html, body').animate({
                    'scrollTop': angular.element('.jwsdw-bonus-product-errors-container').offset().top - 100
                });
                return;
            }

            vm.proceedingToCheckout = true;
            basketService.prepareCheckout()
                .then(function () {
                    if (!basketService.checkout()) {
                        vm.proceedingToCheckout = false;
                    }

                })
                .catch(function (validationResult) {
                    $log.debug('validation error: ', validationResult);
                    basketService.getBasket(BASKET_ID).then(dataService.basketSuccess);
                    vm.proceedingToCheckout = false;
                });
        }

        /**
         * @description Method to validate the basket and if validation is successful direct the customer to the direct checkout (PayPal Express).
         * @returns {void}
         */
        function directCheckout() {
            vm.proceedingToDirectCheckout = true;
            basketService.prepareCheckout().then(function (validationResult) {
                if (!validationResult.error) {
                    basketService.directCheckout();
                } else {
                    $log.debug('validation error: ', validationResult.errorType);
                    basketService.getBasket(BASKET_ID).then(dataService.basketSuccess);
                    vm.proceedingToDirectCheckout = false;
                }
            });
        }

        /**
         * @description Method to refresh a product view that is about to suffer changes.
         * @param {Object} product - The current product whose view should be refreshed.
         * @param {Promise} promise - A promise returned by a product update function.
         * @returns {Promise} a new promise.
         */
        function _refreshProductView(product, promise) {
            return new Promise((resolve) => {
                product.updating = true;
                promise.then(() => product.updating = false && resolve());
            });
        }

        /**
         * @description Method to refresh certain parts of the basket view that are about to suffer changes.
         * @param {Promise} promise - A promise returned by an update function.
         * @returns {Promise} a new promise.
         */
        function _refreshBasketView(promise) {
            const refreshPromise = new Promise((resolve) => {
                $timeout(function() {
                    $scope.$apply(function() {
                        vm.updating = true;
                        promise.finally(() => vm.updating = false && resolve());
                    });
                });
            });

            return refreshPromise;
        }

        /**
         * @description Method to populate the quantity selector options based on site preference.
         * @returns {undefined}
         */
        function populateCartQuantityOptions() {
            let i = 1;

            if (vm.maxCartQuantityPerItem <= i) {
                vm.quantityOptions = [i];
                return;
            }

            while (i <= vm.maxCartQuantityPerItem) {
                vm.quantityOptions.push(i);
                i++;
            }
        }

        /**
         * @description Method to reveal/hide coupon input.
         * @returns {undefined}
         */
        function toggleCouponInput() {
            vm.couponInputRevealed = !vm.couponInputRevealed;
        }

        /**
         * @description Method to update free shipping progress bar
         * @returns {undefined}
         */
        function updateProgressBar() {
            $timeout(function() {
                $scope.$apply(function() {
                    $(document).find('.jwsdw-basket-progressBar-content').css('width', (100 - dataService.freeShippingPercentage()) + '%');
                });
            });
        }

        /**
         * @description Method to select voucher.
         * @param {Object} voucher current selected voucher
         * @returns {undefined}
         */
        function selectVoucher(voucher) {
            vm.selectedVoucher = voucher;
        }

        /**
         * @description Method to add the voucher to basket.
         * @param {Object} voucher current selected voucher
         * @returns {undefined}
         */
        function addVoucherToBasket(voucher) {
            // logic tries the voucher id as it was entered by the user
            // if no matching code can be found tries uppercase and lowercase versions of the code
            // if still no code is found an error message is displayed

            _refreshBasketView(
                basketService
                    .addVoucher(voucher)
                    .then(couponSuccess, voucherError)
            );
        }

        /**
         * @descropion Method to handle error responses from the add voucher function.
         * @param {Object} errorData - Error data from the endpoint.
         * @returns {undefined}
         */
        function voucherError(errorData) {
            $log.debug('Cart-AddVoucher error:', errorData);
        }

        /**
         * @description Method to trigger update voucher section in the basket.
         * @param {Object} voucherData - The activated voucher object.
         * @returns {Promise} A new promise for tracking the update process.
         */
        function updateVoucherSection(voucherData) {
            vm.voucherSectionUpdating = true;
            $timeout(function() {
                $scope.$apply(function() {
                    dataService.voucherDataSuccess({'data': voucherData});
                    vm.voucherSectionUpdating = false;
                });
            });
        }

        $window.jwsdwMediator.subscribe('updateVoucherSection', function(data) {
            let updatedVoucherData = dataService.updateVoucherData(data);
            updateVoucherSection(updatedVoucherData);
        });

        /**
         * @description Method to check if the bonus outfit is incomplete
         * @returns {Boolean} true if the bonus outfit is incomplete, false otherwise
         */
        function isGiftIncomplete() {
            return dataService.defaultBonusProducts() && dataService.defaultBonusProducts().length > 0;
        }

        /**
         * @description Method to check if the basket has normal product purchases and bonus products
         * @returns {Boolean} true if the basket has normal product purchases and bonus products, false otherwise
         */
        function isMixedBasket() {
            return dataService.isMixedBasket();
        }

        /**
         * @description Gets formatted item data for tracking
         * @param {Array<Object>} items Array of item objects to format
         * @returns {void}
         */
        function _getTrackingItems(items) {
            return items.map(function (item, index) {
                let itemObj = {},
                    categoryPath = {};

                item.categoryPath.split(',').forEach((category, categoryIndex) => {
                    if (categoryIndex === 0) {
                        categoryPath.item_category = category;
                    } else {
                        categoryPath['item_category' + (categoryIndex + 1)] = category;
                    }
                });

                itemObj = {
                    'item_id': item.pid,
                    'item_name': item.pName,
                    'index': index,
                    'item_brand': item.brand,
                    'item_list_id': item.item_list_id,
                    'item_list_name': item.item_list_name,
                    'item_variant': item.colorName,
                    'price': item.adjustedUnitPrice,
                    'quantity': item.qty
                };
                if (item.coupon) {
                    itemObj.coupon = item.coupon;
                }
                if (item.discount) {
                    itemObj.discount = item.discount;
                }

                itemObj = Object.assign(itemObj, categoryPath);

                return itemObj;
            });
        }

        /**
         * @description Method to push gtm event on view cart
         * @returns {undefined}
         */
        function trackViewCart() {
            basketService.getTrackingData().then((data) => {
                try {
                    window.dynamic_tm_data.items = data.items;
                    window.dataLayer = window.dataLayer || [];

                    window.dataLayer.push({ecommerce: null});

                    window.dataLayer.push({
                        'event': 'view_cart',
                        'ecommerce': {
                            'currency': data.currency,
                            'value': data.basketTotalPrice,
                            'items': _getTrackingItems(data.items)
                        }
                    });
                } catch (error) {
                    window.console.debug(error);
                }
            });
        }

        /**
         * @description Method to push gtm event on remove product action
         * @param {Object} product - the product that is removed
         * @returns {undefined}
         */
        function trackRemoveFromCart(product) {
            try {
                var oldLayer = window.dynamic_tm_data;
                var products = _getTrackingItems(oldLayer.items).filter(item => item.item_id === product.id);
                window.dataLayer = window.dataLayer || [];

                window.dataLayer.push({ecommerce: null});

                products[0].index = 0;

                window.dataLayer.push({
                    'event': 'remove_from_cart',
                    'ecommerce': {
                        'currency': oldLayer.currency,
                        'value': products[0].price * products[0].quantity,
                        'items': products
                    }
                });
            } catch (error) {
                window.console.debug(error);
            }
        }

        /**
         * @description Method to track product added to wishlist
         * @param {Object} product - the product that is added to wishlist
         * @returns {void}
         */
        function _trackAddToWishlist(product) {
            try {
                var oldLayer = window.dynamic_tm_data;
                var items = _getTrackingItems(oldLayer.items.filter(item => item.pid === product.id));
                window.dataLayer = window.dataLayer || [];

                window.dataLayer.push({ecommerce: null});

                items[0].index = 0;
                items[0].quantity = 1;

                window.dataLayer.push({
                    'event': 'add_to_wishlist',
                    'ecommerce': {
                        'currency': product.currency,
                        'value': items[0].price,
                        'items': items
                    }
                });
            } catch (error) {
                window.console.debug(error);
            }
        }
    }
}(angular));
